import { Component, OnInit, Input} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-infomodal',
  templateUrl: './infomodal.component.html',
  styleUrls: ['./infomodal.component.scss']
})
export class InfomodalComponent implements OnInit {

  @Input() id;
  @Input() selected;
  @Input() infovalue;
  @Input() selectedDate;
  @Input() mandalName;
  @Input() mandalInfo;
  @Input() showInfo;
  @Input() selectedWeek;
  @Input() mandalInfoRural;
  @Input() districtName;
  @Input() ulbInfo;

  selectedtab;
  population: any = 0;
  colorCode = {
    Scanty: "red",
    Severe: "red",
    Deficient: "orange",
    Moderate: "orange",
    Normal: "green",
    Yes: "red",
    No: "green",
    true: "red",
    false: "green"
  };
  bgcolorCode = {
    Scanty: "red",
    Severe: "red",
    Deficient: "orange",
    Moderate: "orange",
    Normal: "green",
    Yes: "red",
    No: "green"
  };
  stress: any;
  critical: any;
  moderate: any;
  constructor(
    public activeModal: NgbActiveModal
    ) { }

  ngOnInit() {
    // console.log("id!!!!!!!!!!", this.mandalInfo, this.mandalName);
    if (this.selected == 'Mandal Info') {
      this.stress = ProjConstants.DRINKING_WATER_TABLE[this.mandalInfoRural['locationStressIndicator']];
      if (!isNullOrUndefined(this.mandalInfoRural['childLocsStressIndicator'])) {
        Object.values(this.mandalInfoRural['childLocsStressIndicator']).forEach(data => {
          if (data['stressIndicator'] == ProjConstants.SYSTEM_CRITICAL_STRESS) {
            this.critical = data['numberOfLocsAffected'];
          }
          if (data['stressIndicator'] == ProjConstants.SYSTEM_MODERATE_STRESS) {
            this.moderate = data['numberOfLocsAffected'];
          }
          if (data['stressIndicator'] == ProjConstants.SYSTEM_CRITICAL_STRESS || data['stressIndicator'] == ProjConstants.SYSTEM_MODERATE_STRESS) {
            this.population += data['populationImpacted'];
          }
        })
      } 
    }
    if (this.selected == 'ULB Info') {
      this.ulbInfo['stress'] = !isNullOrUndefined(this.ulbInfo['stress']) ? this.ulbInfo['stress'] : 'NA';
      this.ulbInfo['tS'] = !isNullOrUndefined(this.ulbInfo['tS']) && this.ulbInfo['tS']!=='-' ? +(this.ulbInfo['tS']*28316.85).toFixed(2) : '-';
      this.ulbInfo['cD'] = !isNullOrUndefined(this.ulbInfo['cD']) && this.ulbInfo['cD']!=='-' ? +this.ulbInfo['cD'].toFixed(2) : '-';
      this.ulbInfo['deficit'] = !isNullOrUndefined(this.ulbInfo['deficit']) && this.ulbInfo['deficit']!=='-' ? +(this.ulbInfo['deficit']*28316.85).toFixed(2) : '-';
      this.ulbInfo['eOMD'] = this.ulbInfo['cD']!=='-' ? +(this.ulbInfo['cD']*28).toFixed(2) : '-';
      // this.ulbInfo['nTMD'] = !isNullOrUndefined(this.ulbInfo['nTMD']) ? +(this.ulbInfo['nTMD']).toFixed(2) : '-';
      this.ulbInfo['p'] = !isNullOrUndefined(this.ulbInfo['p']) && this.ulbInfo['p']!=='-' ? +this.ulbInfo['p'] : '-';
      this.ulbInfo['stressView'] = ProjConstants.DRINKING_WATER_TABLE[this.ulbInfo['stress']];
      this.ulbInfo['color'] = ProjConstants.DRINKING_WATER_LEGEND_URBAN[this.ulbInfo['stress']]
    }
  }

  checkvalue(value) {
    if(value!=null || value!=undefined)
      return value;
    return '-';
  }

  convertToString(value){
    if(value != undefined && value != null)
      return value.toString();
  }

}
